import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { ScaleEnum } from '../../enums/enumRegistry';
import styles from '../../styles/component.module.scss';
import RoleEnum from '../../enums/RoleEnum';
import DEFAULT_ROUTES from '../../constants/routes';
// components
import PageHeader from '../Header/PageHeader';
import TabView from '../tabView/TabView';
import LLMConfigurationTabview from './LLMConfigurationTabview';
import NLPConfigurationTabview from './NLPConfigurationTabview';
import NLPConfiguration from './NLPConfiguration';

const ModelConfiguration = () => {
  const selectedProject = useSelector(state => state.projects.selectedProject);
  const activePage = useSelector((state) => state.navigation.activePage);
  const userRole = useSelector((state) => state.auth.user?.roles);
  const planName = useSelector((state) => state.auth.user?.plan_name);
  const isOrgAdmin =
    userRole?.includes(RoleEnum.ORGANIZATION_ADMIN.name) ||
    userRole?.includes(RoleEnum.SUPER_ADMIN.name);

  if (!isOrgAdmin || planName === 'trial') {
    return <Navigate to={DEFAULT_ROUTES.BASE_URL} replace />;
  }

  const tabsData = [
    {
      name: 'LLM Configuration',
      component: <LLMConfigurationTabview />
    },
    {
      name: 'NLP Configuration',
      component: <NLPConfiguration />
    }
  ];

  // Breadcrumb items
  const breadcrumbItems = [
    { label: 'Administration' },
    { label: activePage}
  ];

  return (
    <Box className={styles['page-container']}>
      <PageHeader
        projectName={selectedProject?.name || null}
        title="Configuration"
        description="Configure and manage the AI model and NLP settings"
        activePage={activePage}
        breadcrumbItems={breadcrumbItems}
        actions={[]}
      />
       
      <Box sx={{ width: '100%', paddingX: 2, paddingTop: 0}} className={styles['cover-container-col']}>
        <TabView 
          tabsData={tabsData} 
        />
      </Box>

    </Box>
  );
};

export default ModelConfiguration;
